import { Green, SpbSky1 } from './palette';

export const labelsImportValidationStatusBorder = SpbSky1;
export const labelsImportValidationStatusProgressBarWaiting = SpbSky1;
export const labelsImportValidationStatusProgressBarSuccess = Green;
